import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectRefinementShopTable(state),
        type: 'refinement-shop',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRefinementShop,
    changeFilter: action.changeFilterRefinementShop,
    toggleSort: action.toggleSortRefinementShop,
    toggleMultiSort: action.toggleMultiSortRefinementShop,
    gotoPage: action.gotoPageRefinementShop,
    initialColumnsVisibility: action.initialTableSettingsRefinementShop,
    toggleColumnVisibility: action.toggleColumnVisibilityRefinementShop,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RefinementShopSalesOrderSearchContainer.js